import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "truncate" })
export class TruncatePipe implements PipeTransform {
  public transform(s: string, limit: number, tail?: string) {
    if (!(s && s.length)) {
      return s;
    }
    if (s.length <= limit) {
      return s;
    }
    return s.substr(0, limit) + (tail || "");
  }
}
